import React, { useState } from 'react'
import './Modes.css';
import { ReactComponent as ModesIcon } from '../../assets/modes.svg';
import { ReactComponent as DarkIcon } from '../../assets/Dark-Mode.svg';

import {
    enable as enableDarkMode,
    disable as disableDarkMode,
} from 'darkreader';
// Keep shared header classes for layout (iconContainer) coming from Header.module.css
import MyHeader from '../Header/Header.module.css';

function Modes({ isMobile }) {

    const [darkMode, setDarkMode] = useState(true)
    // Element got to apply styles on specific Modes
    let toolBars = document.getElementsByClassName('rdw-option-wrapper'); // Corrected class name
    let toolBarsArray = Array.from(toolBars);

    const setMode = () => {
        if (darkMode) {
            enableDarkMode({
                brightness: 100,
                contrast: 90,
                sepia: 10,
            });

            toolBarsArray.forEach((tool) => {
                tool.style.backgroundColor = 'rgba(126, 126, 126, 0)';
                tool.style.filter = 'invert(65%) ';
            });

        } else {
            disableDarkMode();
            toolBarsArray.forEach((tool) => {
                tool.style.backgroundColor = 'rgba(126, 126, 126, 0)';
                tool.style.filter = 'none';
            });

        }
        setDarkMode(!darkMode)
    }
    return (
        <div className={MyHeader.iconContainer} onClick={setMode}>
            {darkMode === false ?
                <ModesIcon className="modeIcon" /> :
                <DarkIcon className="modeIcon" />}
        </div>
    )
}

export default Modes
